module.exports = __webpack_public_path__ + "static/service2-a55d49499792a4f29193a2d7161884b2.jpg";